import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../config/redux/reducers";
import { useUACHelper } from '../../contexts/UACContext';
import UACConstants from '../../constants/UACConstants';
import BaseDriverDetails from "../shared/codPortalBaseDriverDetails";
import {
  fetchOrdersList,
  reconcileCollectedAmtForOrder,
  openCollectionConfirmation,
} from "./redux/codPortalSlice";
import {
  codPortalOrdersDataTransform,
  createPayloadToFetchOrdersList,
  createPayloadToCollectAmount,
} from "../../mocks/codPortal/response.transforms";
import { CellParams } from "../../common/GridWrapper/DataTable";
import { Grid, Typography, SvgIcon } from "@material-ui/core";
import { ReactComponent as RapydIcon } from "../../assets/icons/Lightning.svg";
import { isRapydActivity } from "utils/helpers.utils";
import {getConsignmentStatusField} from '../../mocks/SharedTransform/response.transforms';

interface CODDriverDetailsProps {
  open: boolean;
  driverDetails: any;
  dashboardHub: any;
  dateRange: any;
  closePopup: () => void;
}

const CODDriverDetails = (props: CODDriverDetailsProps) => {
  const {
    expOrdersData: ordersData,
    loading,
    isAmtCollectedForExpressOrders: isAmtCollected,
    expOrdersFiltersDropdowns: ordersFiltersDropdowns,
    expOrdersOnDriverDetails: ordersOnDriverDetails,
    expCodAmtOnDriverDetails: codAmtOnDriverDetails,
    expCodPendingOnDriverDetails: codPendingOnDriverDetails,
    expCodReceivedOnDriverDetails: codReceivedOnDriverDetails,
    expTotalOrdersAmtOnDriverDetails: totalOrdersAmtOnDriverDetails,
  } = useSelector((state: AppState) => state.codPortal);
  
  const uacHelper = useUACHelper();
  const canEditExpressCOD = uacHelper.canEdit(UACConstants.ED_COD);

  const { countryCode } = useSelector((state: AppState) => state.common);

  // Express-specific custom order number renderer with Rapyd icon
  const customOrderNoRenderCell = (params: CellParams) => {
    return (
      <Grid container direction="row" alignItems="center">
        <Grid item>
          <Typography className="idLink">{params.value}</Typography>
        </Grid>
        {isRapydActivity(params?.rowData?.activity) && (
          <SvgIcon className="icon" component={RapydIcon} />
        )}
      </Grid>
    );
  };

  return (
    <BaseDriverDetails
      {...props}
      reduxStates={{
        ordersData,
        loading,
        isAmtCollected,
        ordersFiltersDropdowns,
        ordersOnDriverDetails,
        codAmtOnDriverDetails,
        codPendingOnDriverDetails,
        codReceivedOnDriverDetails,
        totalOrdersAmtOnDriverDetails,
      }}
      transforms={{
        codPortalOrdersDataTransform: codPortalOrdersDataTransform,
        getConsignmentStatusField,
        createPayloadToFetchOrdersList,
        createPayloadToCollectAmount,
      }}
      actions={{
        fetchOrdersList,
        reconcileCollectedAmt: reconcileCollectedAmtForOrder,
        openCollectionConfirmation,
      }}
      canEdit={canEditExpressCOD}
      countryCode={countryCode}
      customOrderNoRenderCell={customOrderNoRenderCell}
    />
  );
};

export default CODDriverDetails;